import { getJSON, canUseProxy, getMainHost } from './utils';

let data = {};
let isCreating = false;
let waitResolveArr = [];
const MAIN_HOST = getMainHost();

// 解决首次同时请求导致多次请求接口的问题
if (canUseProxy()) {
  data = new Proxy(data, {
    set(target, property, value) {
      target[property] = value;
      if (property == 'info' && value && waitResolveArr.length) {
        for (let key in waitResolveArr) {
          try {
            waitResolveArr[key]();
          } catch (_error) {}
        }
      }
      return true;
    }
  });
}

const waitPromise = () => {
  return new Promise(resolve => {
    waitResolveArr.push(resolve);
  });
};

export const getIpInfo = async () => {
  if (data.info) {
    return Promise.resolve(data.info);
  }
  if (isCreating) {
    await waitPromise();
    return data.info;
  }
  if (canUseProxy()) {
    isCreating = true;
  }
  let res = await getJSON(`https://gcollectsecond.octlib.com/Index/GetFP`);
  if (res && res.result == 1) {
    data.info = res.data;
  }
  isCreating = false;
  return data.info;
};
